<template>
  <teleport to="body">
    <div class="login-dialog-root" aria-hidden="false">
      <transition name="fade">
        <div v-if="visible" class="login-overlay" @click="onOverlayClick"></div>
      </transition>
      <transition :name="animationName">
        <div v-if="visible" class="login-dialog" role="dialog" aria-modal="true" aria-label="login">
          <div v-if="isEmbeddedH5" class="dialog-body-h5">
            <img src="@/assets/images/home/tixing.svg" class="w-40px h-40px" />
            <img src="@/assets/images/home/close_error.svg" class="w-24px h-24px absolute top-15px right-10px"
              @click="goToOut" />

            <div class="color-#01031B text-16px font-900 my-10px">
              {{ t('dialog.loginError') }}
            </div>

            <div class="text-14px color-#01031B text-center mb-20px">
              {{ t('dialog.loginErrorMessage') }}
            </div>
            <div class="btn-out" @click="handleContactUs">
              {{ t('dialog.contactUs') }}
            </div>
          </div>
          <div class="dialog-body" v-else>
            <div class="flex items-center overflow-hidden">
              <div class="w-20px h-20px">
                <img src="@/assets/images/home/logo.svg" alt="logo" class="w-full h-full" />
              </div>
              <div class="logo-text text-12px mt-7px ml-6px font-bold">
                {{ JSON.parse(parsed || '{}').AppName || 'Aishmin' }}
              </div>
            </div>
            <div class="logo" aria-hidden="true">
              <!-- <img src="@/assets/images/other/girl.webp" alt="logo" class="w-full h-full" /> -->
            </div>
            <div class="logo_bg_text">
              <img src="@/assets/images/other/Start Your Character.webp" alt="logo" class="w-full h-full" />
            </div>

            <div class="actions pt-110px">
              <div class="guest-up flex align-center relative " @click="handleGuestUp">
                <div class="guest-up-img w-16px h-16px absolute left-30px top-12px">
                  <img src="@/assets/images/login/guest_up.webp" alt="logo" />
                </div>
                <div class="guest-up-text">{{ t('login.guestMode') }}</div>
              </div>

              <div class="google-up flex align-center relative " @click="handleGoogleUp" v-if="!isEmbeddedH5">
                <div class="guest-up-img w-16px h-16px absolute left-30px top-12px">
                  <img src="@/assets/images/login/google_up.webp" alt="logo" />
                </div>
                <div class="guest-up-text">{{ t('login.signInWithGoogle') }}</div>
              </div>

              <div class="sign-up flex align-center relative " @click="handleRegister">
                <div class="guest-up-img w-16px h-16px absolute left-30px top-12px">
                  <img src="@/assets/images/login/sign_up.webp" alt="logo" />
                </div>
                <div class="guest-up-text">{{ t('login.signUp') }}</div>
              </div>

              <div class="sign-in flex align-center relative " @click="handleSignIn">
                <div class="guest-up-img w-16px h-16px absolute left-30px top-12px">
                  <!-- <img src="@/assets/images/login/sign_up.webp" alt="logo" /> -->
                </div>
                <div class="guest-up-text">{{ t('login.signIn') }}</div>
              </div>
            </div>

            <div class="terms">
              {{ t('login.bySigningUp') }}
              <br />
              <span class="link color-#ABB6FF" @click="router.push('/terms'), close()">{{ t('login.userAgreement')
              }}</span>
              <span class="link color-#ABB6FF" @click="router.push('/policy'), close()">{{ t('login.privacyPolicy')
              }}</span>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { ref, watch, computed, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { showLoadingToast, showSuccessToast, showErrorToast,closeToast } from '@/utils/toast'
import { theme } from '@/styles/theme'
import { useWaterfallStore } from '@/stores/waterfall'
import { googleTokenLogin } from 'vue3-google-login'
import CryptoJS from 'crypto-js'
import { useMessageStore } from '@/stores/message'
import { useStorePageStore } from '@/stores/store'
import bridge from '@/utils/bridge'

const props = defineProps({
  show: { type: Boolean, default: false },
  closeOnClickOverlay: { type: Boolean, default: true },
  escToClose: { type: Boolean, default: true },
  animation: { type: String as () => 'pop' | 'slide-up' | 'flip', default: 'flip' }
})

const emit = defineEmits<{
  (e: 'update:show', value: boolean): void
  (e: 'success'): void
}>()

const { t } = useI18n()
const router = useRouter()
const userStore = useUserStore()
const visible = ref(props.show)
const waterfallStore = useWaterfallStore()
const messageStore = useMessageStore()
const storePageStore = useStorePageStore()
const isEmbeddedH5 = computed(() => userStore.getIsEmbeddedH5())
const parsed = localStorage.getItem('ai-chat-parsed')
const userData = computed(() => JSON.parse(localStorage.getItem('ai-chat-user') || '{}'))
const animationName = computed(() => {
  if (props.animation === 'slide-up') return 'slide-up'
  if (props.animation === 'flip') return 'flip'
  return 'dialog-pop'
})

watch(() => props.show, v => (visible.value = v))
watch(visible, v => emit('update:show', v))

// 锁定背景滚动
watch(visible, (v) => {
  if (typeof document !== 'undefined') {
    document.body.style.overflow = v ? 'hidden' : ''
  }
}, { immediate: true })

const close = () => {
  if (isEmbeddedH5.value) {
    visible.value = true
  } else {
    visible.value = false

  }
}

const onOverlayClick = () => {
  if (props.closeOnClickOverlay) close()
}

const onKeydown = (e: KeyboardEvent) => {
  if (!visible.value) return
  if (props.escToClose && (e.key === 'Escape' || e.key === 'Esc')) {
    e.preventDefault()
    close()
  }
}

const goToOut = () => {
  userStore.logOut()
  bridge.callApp('appClose')
}

onMounted(() => {
  window.addEventListener('keydown', onKeydown)
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeydown)
})

/**
 * 登录成功后刷新首页数据
 */
const refreshHomeData = async () => {
  try {
    // 刷新瀑布流数据
    await waterfallStore.getTabNavs()
    await waterfallStore.refresh(0, waterfallStore.tabNavs[0].id, true)
    Promise.allSettled([
      messageStore.switchTab(1),
      messageStore.switchTab(2),
      storePageStore.fetchRechargeItems(),
      storePageStore.fetchConsumptionRecords()
    ])
  } catch (error) {
    console.error('Failed to refresh home data:', error)
  }
}

/**
 * 游客登录
 */
const handleGuestUp = async () => {
  try {
    showLoadingToast(t('login.loggingIn'))
    await userStore.loginTouristFunc()
    await userStore.getUserInfo()
    router.push({ name: 'Home' })
    showSuccessToast(t('login.loginSuccess'))

    // 刷新首页数据
    await refreshHomeData()
  } catch (error) {
    showErrorToast(error as string)
    console.error('Guest login failed:', error)
  } finally {
    // closeToast()
    close()
  }
}

/**
 * 谷歌登录
 */
const handleGoogleUp = async () => {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID
  try {
    showLoadingToast(t('login.loggingIn'))
    const response = await googleTokenLogin({ clientId })
    const encryptedToken = CryptoJS.MD5(response.access_token).toString()
    await userStore.googleLogin(encryptedToken)

    // 刷新首页数据
    await refreshHomeData()
    router.push('/')
    showSuccessToast(t('login.loginSuccess'))
  } catch (error) {
    showErrorToast(error as string)
  } finally {
    // closeToast()
    close()
  }
}
/**
 * 注册
 */
const handleRegister = () => {
  router.push({
    path: '/login',
    query: {
      isRegisterUrl: 'true',
      isSignInUrl: 'false',
      isLoginUrl: 'true'
    }
  })
  close()

}

/**
 * 登录
 */
const handleSignIn = () => {
  router.push({
    path: '/login',
    query: {
      isRegisterUrl: 'false',
      isSignInUrl: 'true',
      isLoginUrl: 'true'
    }
  })
  close()

}

const handleContactUs = () => {
  showLoadingToast(t('dialog.processing'),{duration: 2000})
  window.location.href = userData.value.contactUs || 'https://discord.gg/WNTyxU5mHk'
}
onMounted(()=>{
    closeToast()
})
</script>

<style scoped lang="scss">
.login-dialog-root {
  position: fixed;
  inset: 0;
  z-index: 999;
  pointer-events: none;
  perspective: 1200px;
}

.login-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);

  pointer-events: auto;
}

.login-dialog {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(100vw - 48px);
  max-width: 420px;
  border-radius: 12px;
  // overflow: hidden;
  background: linear-gradient(180deg, #444459 0%, #454255 100%);
  pointer-events: auto;
}

/* Overlay fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Dialog pop */
.dialog-pop-enter-active,
.dialog-pop-leave-active {
  transition: opacity .22s ease, transform .22s cubic-bezier(0.22, 1, 0.36, 1);
}

.dialog-pop-enter-from,
.dialog-pop-leave-to {
  opacity: 0;
  transform: translate(-50%, -44%) scale(0.96);
}

/* Slide up */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: opacity .22s ease, transform .22s cubic-bezier(0.22, 1, 0.36, 1);
}

.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translate(-50%, -38%) scale(1);
}

/* Flip */
.flip-enter-active,
.flip-leave-active {
  transition: opacity .28s ease, transform .28s cubic-bezier(0.22, 1, 0.36, 1);
  transform-style: preserve-3d;
}

.flip-enter-from {
  opacity: 0;
  transform: translate(-50%, -50%) rotateX(-90deg) scale(0.96);
}

.flip-leave-to {
  opacity: 0;
  transform: translate(-50%, -50%) rotateX(90deg) scale(0.96);
}

.dialog-body {
  padding: 20px;
  background: linear-gradient(180deg, #444459 0%, #454255 100%);
  border-radius: 10px;
}

.dialog-body-h5 {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  padding: 20px;
  background: linear-gradient(180deg, #FFD8D8 0%, #FFFFFF 100%);
}

.logo {
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
  width: 148px;
}

.logo_bg_text {
  position: absolute;
  top: 110px;
  left: 50%;
  transform: translateX(-50%);
  width: 260px;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.actions {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .guest-up,
  .google-up,
  .sign-up,
  .sign-in {
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 44px;
    border-radius: 32px;
    font-weight: 900;
    font-size: 15px;
  }

  .guest-up {
    background: linear-gradient(180deg, #ffffff 0%, #dacaff 100%);
    color: #333;
  }

  .google-up {
    background: linear-gradient(180deg, #9b75f3 0%, #6026cf 100%);
    color: #fff;
  }

  .sign-up {
    background: linear-gradient(#5a68ff, #5a68ff 0%, #95a5ff 100%);
    color: #fff;
  }

  .sign-in {
    background: v-bind('theme.colors.backgroundSecondary');
    color: #abb6ff;
  }

  .sign-in-text {
    font-weight: 500;
    font-size: 12px;
    color: v-bind('theme.colors.textPrimary');

    span {
      text-decoration: underline;
    }
  }
}

.action {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 8px;
  background: #f5f5f7;
  color: #111;
}

.action img {
  width: 16px;
  height: 16px;
  margin-left: 20px;
}

.action span {
  flex: 1;
  text-align: center;
  margin-right: 36px;
}

.action.primary {
  background: #111827;
  color: #fff;
}

.action.secondary {
  background: #e5e7eb;
}

.action.google {
  background: #ffffff;
  border: 1px solid #e5e7eb;
}

.action.guest {
  background: #f9fafb;
}

.terms {
  margin-top: 8px;
  text-align: center;
  font-size: 12px;
  color: #6b7280;
}

.terms .link {
  // color: #111827;
  text-decoration: underline;
}

.close {
  margin-top: 8px;
  width: 100%;
  height: 36px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #9ca3af;
}

.logo-text {
  background: linear-gradient(45.00000000000004deg, #7C9CFF 0%, #7058F8 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.btn-out {
  background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
  font-weight: 800;
  font-size: 14px;
  color: #FFFFFF;
  border-radius: 23px;
  padding: 8px 89px;
}
</style>
